import type { TSupportedLocale } from '@docue/builder/i18n'
import type { TJurisdictionCode } from '@docue/builder-intl'
import type { TContractConfig } from '@docue/builder/contract/config'

import type { IncludedFieldDependentResponse, Response } from '~/types/api/v2'

import { useApiV2FetchFactory } from '../../useApiV2FetchFactory'

type UserTemplateV2Data = App.Data.UserTemplate.UserTemplateData

export type IncludableField = 'owner' | 'template'

export type UserTemplateV2ResponseData<T extends IncludableField[] = []> =
  IncludedFieldDependentResponse<UserTemplateV2Data, T, IncludableField>

export const responseDataTypeName = 'userTemplateV2'

interface UpdatePayload {
  name?: string
  contract_config?: TContractConfig
}

export const useFetchUserTemplateV2 = () => {
  const url = '/v2/user-templates'

  const { createGetById, createUpdate } = useApiV2FetchFactory<UserTemplateV2Data, IncludableField>(url)

  // Calls the Nuxt server proxy (which builds the contract_config and forwards
  // to POST /v2/user-templates) instead of hitting the internal API directly.
  const create = ({
    name,
    language,
    jurisdiction,
  }: {
    name: string
    language: TSupportedLocale
    jurisdiction: TJurisdictionCode
  }) =>
    $fetch<Response<UserTemplateV2Data>>('/api/user-template/create', {
      method: 'POST',
      body: { name, language, jurisdiction },
    })

  return {
    getById: createGetById(),
    update: createUpdate<UpdatePayload>(),
    create,
  }
}
